<template>
  <NuxtLayout #="{ showModalMessages }">
    <div class="slot-body">
      <h1 class="visually-hidden">{{ route.params.language === 'pt-br' ? 'Colunas e Conteúdo Exclusivo dos Colunistas do Bella' : 'Columns and Exclusive Content from the Bella Columnists' }}</h1>
      <div v-if="!isMobile()" class="box-gray"></div>
      <div class="container">
        <div class="row pt-5 align-items-center">
          <div class="col-lg-2 col-4 order-1 order-lg-1">
            <div class="title mt-4">
              {{ translate.title }}
            </div>
          </div>
          <div class="col-lg-5 col-12 order-3 order-lg-2">
            <span class="subtitle">
              {{ translate.subTitle }}
            </span>
          </div>
          <div
            class="col-lg-4 col-7 order-2 order-lg-3 d-flex align-items-center box-input"
          >
            <input
              type="text"
              name="search"
              id="search-columns"
              :placeholder="translate.searchPlaceholder"
              v-model="search"
              @keyup.enter="searchColumns(showModalMessages)"
              @keyup="clearSearchText"
            />
            <font-awesome
              :icon="['fas', 'search']"
              size="sm"
              @click="searchColumns(showModalMessages)"
            />
          </div>
        </div>
        <div class="mt-4" v-if="!searchText">
          <ColunasHome
            :title-visible="false"
            :button-mobile="false"
            :button-more="false"
            @getArticleTagId="getArticleTagId"
          />
        </div>
        <div class="mt-3">
          <div v-if="searchText">
            <div class="search-div" v-if="searchTextKeyUp">
              <br />{{ translate.searchTerm }} <strong>{{ search }}</strong
              ><br /><br />
            </div>
            <div v-if="searchTextKeyUp && !postColumns.length">
              {{ translate.searchNoRecords }}<br /><br />
            </div>
          </div>
          <ColumnsCardsMobile :posts="postColumns" v-if="isMobile()" />
          <ColumnsCards :posts="postColumns" v-else />
        </div>
        <div
          class="row d-flex align-items-center justify-content-center"
          v-if="postColumns.length >= limit"
        >
          <button
            type="button"
            class="more-blog my-5 p-3 col-lg-3 col-8"
            @click="readMore"
          >
            {{ translate.readMore }}
            <font-awesome :icon="['fas', 'arrow-down']" size="md" />
          </button>
        </div>
        <div
          class="row mt-3 pb-5 d-flex align-items-center justify-content-center"
        >
          <BannerAssineHorizontal :path="bannerAssineHorizontal" />
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import translaters from "@/tradutors/columns";
import ColunasHome from "@/components/HomePage/ColunasHome.vue";
import ColumnsCards from "@/components/ColumnsCards/Cards.vue";
import ColumnsCardsMobile from "@/components/ColumnsCards/CardsMobile.vue";
import { isMobile } from "@/shared/utils/mobile";
import api from "@/api";
import BannerAssineHorizontal from "@/components/HomePage/BannerAssineHorizontal.vue";

definePageMeta({
  middleware: ["not-found-lang"],
});
const route = useRoute();
const canonical = useCanonicalUrl();
const translate = computed(() =>
  route.params.language === "pt-br" ? translaters.portugues : translaters.ingles
);
const storeLocale = localeStore();

const seo = await useSeoConfig(String(route.name), String(route.params.language));

useHead({
  templateParams: {
    subTitle: null,
    subPage: seo.value?.title || translate.value.title,
    page_url: canonical,
    page_description:
      seo.value?.description ||
      (route.params.language == "pt-br"
        ? `Fique atualizado sobre o melhor do universo masculino.`
        : `Stay updated on the best of the male universe.`),
    page_image: shareImage(seo.value?.image),
    page_keywords:
      seo.value?.keywords ||
      "bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site",
    page_locale: route.params.language as string,
    page_url_pt: "https://belladasemana.com.br/pt-br/colunas",
    page_url_en: "https://belladasemana.com.br/en/colunas",
    page_canonical: canonical,
  },
});

const { data } = await useAsyncData("getColumns"+ "-" + route.params.language, async () => {
  return await api
    .get(
      `v1/colunas/getColumns?search=&articletag=&language=${
        route.params.language
      }&limit=10&mobile=${isMobile()}`
    )
    .then(({ data }) => {
      return data.postsColumns;
    });
});

const postColumns = ref(data.value);
const limit = ref(10);
const bannerAssineHorizontal = ref("");
const articleTagId = ref(9999);
const search = ref("");
const searchText = ref(false);
const searchTextKeyUp = ref(false);

watch(search, (value) => {
  if (value == "") {
    searchText.value = false;
    getDados();
  }
});

onMounted(() => {
  getBannerAssineHorizontal();
});

async function getDados() {
  await api
    .get(
      `v1/colunas/getColumns?search=${search.value}&articletag=${
        articleTagId.value
      }&language=${route.params.language ?? ""}&limit=${
        limit.value
      }&mobile=${isMobile()}`
    )
    .then(({ data }) => {
      postColumns.value = data.postsColumns;
    });
  if (search.value != "") {
    searchTextKeyUp.value = true;
  }
}
async function readMore() {
  limit.value += 3;
  await getDados();
}
async function getBannerAssineHorizontal(changeLanguage = false) {
  if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
    api
      .get(
        `v1/home/getBannerSuper?mobile=${isMobile()}&language=${
          route.params.language
        }`
      )
      .then(({ data }) => {
        bannerAssineHorizontal.value = data.bannerAssineHorizontal;
        sessionStorage.setItem(
          "bannerAssineHorizontal",
          JSON.stringify(bannerAssineHorizontal.value)
        );
      });
  else
    bannerAssineHorizontal.value = JSON.parse(
      sessionStorage.getItem("bannerAssineHorizontal") ?? ""
    );
}
function getArticleTagId(data: any) {
  articleTagId.value = data.articleTagId;
  limit.value = 10;
  search.value = "";
  searchText.value = false;
  getDados();
}
function searchColumns(message: any) {
  if (search.value != "") {
    searchText.value = true;
    searchTextKeyUp.value = true;
    articleTagId.value = 9999;
    limit.value = 10;
    getDados();
  } else {
    searchText.value = false;
    return message({
      message: {
        show: true,
        title: route.params.language == "pt-br" ? "Aviso" : "Notice",
        textButton: route.params.language == "pt-br" ? "Fechar" : "Close",
        textBoby:
          route.params.language == "pt-br"
            ? "Informe algum termo para busca!"
            : "Enter a search term",
      },
    });
  }
}
function clearSearchText() {
  searchTextKeyUp.value = false;
}
</script>

<style scoped lang="css">
.slot-body {
  margin-top: 65px !important;
  background-color: #fff !important;
}

.box-gray {
  background-color: #f8f8f8;
  width: 100%;
  height: 333px;
  position: absolute;
}

.title {
  font-family: "Bebas-Neue-Light";
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

#search-columns {
  padding: 0 !important;
  padding-left: 30px !important;
  font-size: 1rem !important;
  background-color: #ffffff !important;
  border: 1px solid #ced4da !important;
  border-radius: 30px !important;
  height: 51px !important;
  width: 100%;
}

.box-input {
  margin-top: 6px;
}

.box-input svg {
  position: absolute;
  right: 45px;
  z-index: 9;
  color: #b20;
  cursor: pointer;
}

.subtitle {
  height: 56px;
  color: #5b5858;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.more-blog {
  font-size: 1rem !important;
  font-weight: 500;
  background-color: black !important;
  border: 1px solid black !important;
  border-radius: 30px !important;
  color: white;
}

.more-blog svg {
  color: #b20;
  margin-left: 8px;
}

.search-div {
  top: -50px;
  position: absolute;
}

@media screen and (max-width: 769px) {
  .subtitle {
    display: none;
  }

  .title {
    font-family: "Bebas-Neue-Light";
    color: #000000;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 58px;
  }

  #search-columns {
    height: 38px !important;
    padding-left: 10px !important;
    font-size: 0.8rem !important;
    background-color: #eaeaea !important;
  }

  .box-input svg {
    right: 20px;
    z-index: 9;
  }

  .search-div {
    top: -55px;
  }
}
</style>
